var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKcllcGrennIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.196,
    height: 16.972,
    viewBox: "0 0 28.196 16.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#55bbac}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1498",
    transform: "translate(19278.999 -14798.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6645",
    d: "M1117.38 1853.4h16.809l-8.387 8.486 8.387 8.486h-16.809z",
    className: "cls-1",
    transform: "translate(-20396.379 12944.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6646",
    d: "M1150.674 1853.4l-8.394 8.486 8.394 8.486h8.38l-8.408-8.532 8.408-8.44z",
    className: "cls-1",
    transform: "translate(-20409.857 12944.642)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKcllcGrennIcon);
export default __webpack_public_path__ + "static/media/KCLLC_grenn_Icon.3dec70f4a619ee2e5aa923e399d61ddc.svg";
export { ForwardRef as ReactComponent };